import * as React from "react";

import connectToList from "../../../store/list";

import GenCheckboxFilter from "../../Gen/CheckboxFilter";
import GenControlsBar from "../../Gen/ControlsBar";
import GenMore from "../../Gen/More";
import GenSearchBox from "../../Gen/SearchBox";
import GenSortButtons from "../../Gen/SortButtons";

import AddToSummary from "./Summary";

interface AddToListProps {
  documentId: number;
  showsOwnershipCheckbox?: boolean;
  userId?: number;
  canAddToUnownedDocumentSets?: boolean;
  categoryId?: number;
  documentSets: ConnectedList<DocumentSetSnakeModel>;
}

function AddToList(props: AddToListProps) {
  const {
    documentId,
    showsOwnershipCheckbox,
    userId,
    canAddToUnownedDocumentSets,
    categoryId,
    documentSets,
  } = props;

  React.useEffect(() => {
    documentSets.mountList("/document_sets");
  }, []);

  return (
    <div>
      <GenControlsBar>
        <GenSearchBox
          {...documentSets}
        />
        {showsOwnershipCheckbox && (
          <GenCheckboxFilter
            {...documentSets}
            filterKey="owner"
            option={["=", "document_sets.owner_id", userId]}
            label="Only courses that I own"
          />
        )}
        <GenSortButtons
          {...documentSets}
          sortOptions={[
            {
              "title": "Name",
              "value": "document_sets.name",
            },
            {
              "title": "Owner",
              "value": "users.last_name",
            },
          ]}
        />
      </GenControlsBar>
      {
        documentSets.listData?.map((documentSet) => {
          const locked = documentSet.locked;
          const isOwner = documentSet.owner_id && documentSet.owner_id == userId;
          const enabled = !locked || !!isOwner || !!canAddToUnownedDocumentSets;

          return(
            <AddToSummary
              enabled={enabled}
              key={documentSet.id}
              documentSet={documentSet}
              documentId={documentId}
              includesDoc={documentSet.nested_document_ids.includes(documentId)}
              categoryId={categoryId}
            />
          );
        })
      }
      <GenMore
        {...documentSets}
        shouldInfiniteScroll
      />
    </div>
  );
}

export default connectToList(AddToList, ["documentSets"]) as React.FC<Omit<AddToListProps, "documentSets">>;
